<template>
  <div id="contenedor-eliminar-subtipo-infraestructura">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar subtipo de infraestructura </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el subtipo de infraestructura? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarSubtipoInfraestructura"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixSubtiposInfraestructura from './mixSubtiposInfraestructura';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarSubtipoInfraestructura',
  mixins: [mixSubtiposInfraestructura],
  props: {
    subtipoInfraestructuraEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped></style>
